/* index.js */

"use strict";
const Steve = require("@gluenetworks/steve_core").getInstance();
const Dashboard = require("./src/app/DashboardComponent");
const Registrations = require("./src/Registrations");

Steve.di.registry.register(Registrations.DASHBOARD_SECTION, Dashboard);

module.exports = Dashboard;
module.exports.Registrations = Registrations;
